import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import { IOrganisationIndex } from "../model/OrganisationIndex";
import OrganisationIndexMapper from "../service/OrganisationIndexMapper";
import OrganisationIndexParamMapper from "../service/OrganisationIndexParamMapper";

export default class UpdateOrganisationIndexInteractor {
  private updateResource: UpdateResourceInteractor<IOrganisationIndex>;

  constructor({ updateResource }: any) {
    this.updateResource = updateResource;
  }

  async execute(model: IOrganisationIndex) {
    const result = await this.updateResource.execute(
      `organisations/${model.organisationId}/indexes`,
      OrganisationIndexMapper,
      OrganisationIndexParamMapper,
      model,
      model.id,
      undefined,
      false
    );

    return result;
  }
}
